import { css, styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { cssFontSize, cssSpacing, surfaceColorMap } from "../../util/styles.js";
import type { BackgroundColor } from "../../types/theme.js";

const surfaceCss = (bg: BackgroundColor) => css`
  padding: ${cssSpacing("s")};
  border-radius: ${(p) => p.theme.borderRadius};
  background-color: ${surfaceColorMap[bg]};

  ${bg === "surface3" &&
  css`
    --markets-title-color: #fff;
    --markets-link-color: #fff;
    --markets-link-hover-color: var(--swatch4);
    --markets-icon-color: #fff;
  `}

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${cssSpacing("m")};
  }
`;

export const MarketsLayout = styled.div<{ $bg?: BackgroundColor }>`
  ${(p) => p.$bg && surfaceCss(p.$bg)}
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  @media (min-width: ${mobileBreakPointCSS}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: ${cssSpacing("s")};
    align-items: center;
  }
`;

export const MarketsBody = styled.div`
  min-width: 0;

  @media (min-width: ${mobileBreakPointCSS}) {
    grid-column: 1 / 3;
  }
`;

export const MarketsTitle = styled.h2`
  margin: 0 0 ${cssSpacing("s")};
  color: var(--markets-title-color, var(--swatch2));
  font-family: inherit;
  font-size: ${cssFontSize("large")};
  font-weight: 600;
  line-height: 1.3333;
  text-align: center;

  @media (min-width: ${mobileBreakPointCSS}) {
    margin-bottom: ${cssSpacing("m")};
    font-size: ${cssFontSize("larger")};
    text-align: left;
  }
`;

export const MarketsLinks = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${cssSpacing("s")};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const MarketsLink = styled.a`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  color: var(--markets-link-color, var(--swatch1));
  font-size: ${cssFontSize("small")};
  font-weight: 400;
  line-height: 1.4;
  text-decoration-line: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;

  svg {
    flex-shrink: 0;
    color: var(--markets-icon-color, var(--secondary-icon-color));
    transition: transform 0.2s cubic-bezier(0.32, 0.72, 0.26, 1);
  }

  span {
    display: inline-block;
  }

  &:hover,
  &:focus-visible {
    color: var(--markets-link-hover-color, var(--swatch2));
    text-decoration-line: none;

    svg {
      transform: translateX(3px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    svg {
      transition: none;
    }
  }
`;

export const MarketsMedia = styled.div`
  display: none;
  position: relative;
  width: 100%;
  height: 240px;
  overflow: hidden;
  border-radius: ${(p) => p.theme.borderRadius};

  @media (min-width: ${mobileBreakPointCSS}) {
    grid-column: 3;
    display: block;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
